import { render } from "./componentEditVideo.vue?vue&type=template&id=64f295ea"
import script from "./componentEditVideo.vue?vue&type=script&lang=js"
export * from "./componentEditVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__